import { FC } from "react";


export const NotFoundPage: FC<{}> = () => {
  return null;
}

